import { render, staticRenderFns } from "./AvatarBuilderMixAndMatchCategory.vue?vue&type=template&id=6cd11940&scoped=true&"
import script from "./AvatarBuilderMixAndMatchCategory.vue?vue&type=script&lang=js&"
export * from "./AvatarBuilderMixAndMatchCategory.vue?vue&type=script&lang=js&"
import style0 from "./AvatarBuilderMixAndMatchCategory.vue?vue&type=style&index=0&id=6cd11940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd11940",
  null
  
)

export default component.exports